import { defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import { DevicePlatformEnum } from '../shared/schemas/filterMappings.js';

export const createPlatformMappings = defaultClient.mutation({
  url: 'omni-trafficking/v1/platform-mappings/' as const,
  method: 'POST',
  responseSchema: z.object({}),
  processResponse(data) {
    return data;
  },
  requestSchema: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
      appsflyerDevicePlatform: DevicePlatformEnum.nullish(),
      adformUuid: z.string().nullish(),
    }),
  ),
  querySchema: z.object({
    settingsId: z.string(),
    platformId: z.string(),
    platformName: z.string(),
  }),
  snakeCaseQueryParams: true,
});

export const deletePlatformMappings = defaultClient.mutation({
  url: 'omni-trafficking/v1/platform-mappings/delete/' as const,
  method: 'DELETE',
  responseSchema: z.object({}),
  querySchema: z.object({
    settingsId: z.string(),
    platformId: z.string(),
    platformMappingId: z.array(z.string()),
  }),
  snakeCaseQueryParams: true,
  processResponse(data) {
    return data;
  },
});
